import { render, staticRenderFns } from "./DeviceRoutes.vue?vue&type=template&id=7d686d0a&scoped=true"
import script from "./DeviceRoutes.vue?vue&type=script&lang=js"
export * from "./DeviceRoutes.vue?vue&type=script&lang=js"
import style0 from "./DeviceRoutes.vue?vue&type=style&index=0&id=7d686d0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d686d0a",
  null
  
)

/* custom blocks */
import block0 from "./DeviceRoutes.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports